var _style, _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 946 760",
    style: {
      enableBackground: "new 0 0 946 760"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;clip-path:url(#SVGID_2_);}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.72;stroke-linecap:round;stroke-linejoin:round;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 302") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: -0.4,
    width: 945,
    height: 762.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP-1.1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chopLight-1",
    transform: "translate(-78.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-302",
    transform: "translate(79.000000, -144.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    className: "st1",
    points: "615.1,630.1 213.4,1001.7 121.8,1104.3 45,1399.5 86.5,1436.5 93.2,1436.8  309.2,1194.5 309.7,1175.4 313.8,1165.3 950.4,451.1 952,397.8 885.4,395.8 645.1,626.1 615.1,630.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-2",
    className: "st1",
    points: "468.7,401.3 468.7,346.8 522,252.7 522,146.6 475.2,99.8 335.6,99.8 335.6,147.7  340.2,158.8 351.6,163.6 404.8,163.6 431.2,174.5 442.1,200.9 442.1,212.2 440.6,224.6 436.4,236.3 213.1,673.7 128.9,793.8  121.3,800.5 111.4,802.8 106.8,802.8 0,923.4 0,1008.2 88,1085.8 195.3,964.6 312.8,773.5 314.3,767.9 314.3,736.5 315.8,731.2  397,590.5 398.4,585.2 398.4,534.4 468.7,401.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-5",
    className: "st1",
    d: "M916,587.5l-64-1.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-17",
    className: "st1",
    d: "M915.4,587.5c17.6,0.5,32.3-13.3,32.8-30.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-25",
    className: "st1",
    d: "M319.9,1182.4l532.3-596.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-33",
    className: "st1",
    d: "M903.9,353.3l42.4,1.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-35",
    className: "st1",
    points: "903.9,353.3 902.5,395.9 945.1,397.1 946.3,354.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-37",
    className: "st1",
    points: "1082.5,365 949.3,361.1 949.6,354.7 898.6,353.2 906.1,104.2 1082.5,109.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-49",
    className: "st1",
    d: "M901.2,264.8l155.9-155.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-51",
    className: "st1",
    d: "M900.2,295.9l182.2-182.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-53",
    className: "st1",
    d: "M899.4,326.8l183.1-183.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-55",
    className: "st1",
    d: "M903.1,353.3l179.4-179.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-57",
    className: "st1",
    d: "M932.3,354.1l150.2-150.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-69",
    className: "st1",
    d: "M932.7,354.1l13.4,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-71",
    className: "st1",
    d: "M909.4,353.4l36,35.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-73",
    className: "st1",
    d: "M903.4,370l26.7,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-75",
    className: "st1",
    d: "M902.7,391.9l4.1,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-119",
    className: "st1",
    d: "M936.2,580.8l146.2,53.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-121",
    className: "st1",
    d: "M890.8,587l191.7,69.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-123",
    className: "st1",
    d: "M845.7,593.1l236.8,86.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-125",
    className: "st1",
    d: "M830.4,610.2l252.1,91.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-127",
    className: "st1",
    d: "M815.1,627.4l267.4,97.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-129",
    className: "st1",
    d: "M799.8,644.4l282.6,102.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-131",
    className: "st1",
    d: "M784.5,661.5l297.9,108.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-133",
    className: "st1",
    d: "M769.4,678.7l313.1,113.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-135",
    className: "st1",
    d: "M754.1,695.7l328.3,119.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-137",
    className: "st1",
    d: "M738.8,712.8l343.6,125.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-139",
    className: "st1",
    d: "M723.6,730l358.9,130.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-141",
    className: "st1",
    d: "M708.3,747l374.2,136.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-143",
    className: "st1",
    d: "M693.1,764.1l389.3,141.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-145",
    className: "st1",
    d: "M677.9,781.1l404.6,147.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-147",
    className: "st1",
    d: "M662.6,798.3l419.9,152.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-149",
    className: "st1",
    d: "M647.3,815.3l435.1,158.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-151",
    className: "st1",
    d: "M632,832.4l450.4,164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-153",
    className: "st1",
    d: "M616.9,849.6l465.6,169.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-155",
    className: "st1",
    d: "M601.6,866.6l480.8,175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-157",
    className: "st1",
    d: "M586.3,883.7l496.1,180.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-159",
    className: "st1",
    d: "M571.1,900.9l511.4,186.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-161",
    className: "st1",
    d: "M555.9,917.9l526.5,191.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-163",
    className: "st1",
    d: "M540.6,935l541.8,197.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-165",
    className: "st1",
    d: "M525.4,952.2l557.1,202.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-167",
    className: "st1",
    d: "M510.1,969.2l572.4,208.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-169",
    className: "st1",
    d: "M494.8,986.3l587.6,213.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-171",
    className: "st1",
    d: "M479.7,1003.3l602.8,219.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-229",
    className: "st1",
    points: "314.6,1164.4 951,450.6 952.6,397.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-231",
    className: "st1",
    points: "47.1,1393.9 122.7,1103.5 214.2,1000.9 869.7,394.8 952.6,397.4  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-243",
    className: "st1",
    d: "M314.1,736.8v31.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-245",
    className: "st1",
    d: "M312.5,773.6c1-1.7,1.6-3.6,1.6-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-253",
    className: "st1",
    d: "M111.5,803.1h-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-255",
    className: "st1",
    d: "M88,1086.1l107.2-121.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-257",
    className: "st1",
    d: "M0.2,923.7l106.7-120.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-259",
    className: "st1",
    d: "M88,1086.1l-87.8-77.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-261",
    className: "st1",
    d: "M195.3,964.9l117.3-191.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-263",
    className: "st1",
    d: "M315.6,731.5l81.2-140.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-265",
    className: "st1",
    d: "M315.6,731.4c-0.9,1.6-1.4,3.4-1.4,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-267",
    className: "st1",
    d: "M398.1,585.4v-37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-269",
    className: "st1",
    d: "M396.7,590.6c0.9-1.6,1.4-3.4,1.4-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-271",
    className: "st1",
    d: "M399.5,543.2L467,420.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-273",
    className: "st1",
    d: "M399.5,543.2c-0.9,1.6-1.3,3.3-1.3,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-275",
    className: "st1",
    d: "M468.3,415.2v-43.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-277",
    className: "st1",
    d: "M467,420.3c0.9-1.6,1.3-3.3,1.3-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-279",
    className: "st1",
    d: "M469.8,366.5L530.7,263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-281",
    className: "st1",
    d: "M469.9,366.4c-1,1.6-1.5,3.5-1.5,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-283",
    className: "st1",
    d: "M532.2,257.5v-95.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-285",
    className: "st1",
    d: "M530.7,262.8c1-1.6,1.5-3.5,1.5-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-291",
    className: "st1",
    d: "M129,794.1l84-120.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-293",
    className: "st1",
    d: "M111.6,802.9c6.9,0,13.4-3.4,17.4-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-295",
    className: "st1",
    d: "M213,673.9l223-437.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-299",
    className: "st1",
    d: "M848.2,341.4c0-93-75.4-168.4-168.4-168.4s-168.4,75.4-168.4,168.4 c0,93,75.4,168.4,168.4,168.4S848.2,434.4,848.2,341.4"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.895a9a08ee70931759575abb4cfd45f1.svg";
export { ForwardRef as ReactComponent };